import { Box, Typography, Grid, Paper, Container } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

const steps = [
  {
    id: 1,
    icon: <EmailIcon fontSize="large" sx={{ color: "#fff" }} />, 
    title: "Fill the Enquiry Form and send it through whatsapp to Reach Us",
    description: "Our travel expert will get back to you with your requirements.",
  },
  {
    id: 2,
    icon: <DirectionsCarIcon fontSize="large" sx={{ color: "#fff" }} />, 
    title: "Choose a Vehicle of Your Choice",
    description: "From our fleet of 10+ vehicles, choose the taxi of your choice and plan your trip accordingly.",
  },
  {
    id: 3,
    icon: <AttachMoneyIcon fontSize="large" sx={{ color: "#fff" }} />, 
    title: "Minimal Advance Payment for Bookings",
    description: "Just 20% of the total amount to book your taxi tour. Rest will be collected during the trip.",
  },
  {
    id: 4,
    icon: <EmojiEmotionsIcon fontSize="large" sx={{ color: "#fff" }} />, 
    title: "Just Enjoy Your Trip",
    description: "It's time to enjoy the memorable journey with Shimla Manali taxi service!",
  },
];

const CarRentalSteps = () => {
  return (
    <Container maxWidth="lg" sx={{ padding: "2rem 0" }}>
      <Grid container spacing={0} alignItems="stretch">
        {/* Left Banner Section */}
        <Grid
          item
          xs={12} md={6}
          sx={{ 
            backgroundColor: "#298067", 
            color: "#fff", 
            padding: { xs: "3rem 5rem", md: "5rem" }, 
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            alignItems: "center",
            textAlign: "center",
            height: "45vh"
          }}
        >
          <Typography variant="h4" sx={{ color: "#FBC02D", fontWeight: "bold" }}>
            Upto 10% Off on First Time Reservations
          </Typography>
          <Typography variant="h1" fontWeight="bold" sx={{ typography: { xs: "h3", md: "h1" } }} gutterBottom>
            4 Simple <span style={{ color: "#FBC02D" }}>Steps</span> To
          </Typography>
          <Typography variant="h1" fontWeight="bold" sx={{ typography: { xs: "h3", md: "h1" } }}>
            Rent a Car in Shimla & Manali!
          </Typography>
        </Grid>
        {/* Right Steps Section */}
        <Grid 
          item 
          xs={12} md={6} 
          sx={{ 
            backgroundColor: "#fff", 
            padding: "2rem", 
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "flex-start", 
            alignItems: "center",
            height: "75vh", 
          }}
        >
          {steps.map((step) => (
            <Paper
              key={step.id}
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "0.5rem",
                marginBottom: "2rem",
                backgroundColor: "#F5F5F5",
                color: "#333",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                width: "100%"
              }}
            >
              <Box
                      sx={{
                        width: 52,
                        height: 52,
                        borderRadius: "50%",
                        background:
                          "linear-gradient(135deg,#0f766e,#14b8a6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        flexShrink: 0,
                      }}

              >
                {step.icon}
              </Box>
              <Box>
                <Typography variant="h6" fontWeight="bold">
                  {step.title}
                </Typography>
                <Typography variant="body1" color="textSecondary">
                  {step.description}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
};

export default CarRentalSteps;
